// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5782a07b","453":"88217d06","455":"aba39bbe","977":"b5a20655"}[chunkId] + ".chunk.js";
};